const Config = {
    API_BASE_URL: 'https://hasbara-ai.com' || 'http://16.16.19.97:3000' || 'http://localhost:3000',
    STATS_ROUTE: '/api/stats',
    RESONSE_GEN_ROUTE: '/api/websiteAnalyzeAndGenerate',
  };
  
  export default Config;
  